import React from 'react';
import '../gral-stylesheets/searchBar.scss';
import { IconUserSearchLine } from '../icons/icons';



class SearchBar extends React.Component {
  render() {
    return (
      <div className='search-bar-container'>
        <form className='form-search-bar'>
          <i> <IconUserSearchLine /> </i>
          <input
            className='form-search-input'
            type='search'
            autoComplete='off'
            placeholder='Ingress your search...'
          />
          <button className='form-buttom'>
            <h3>Search</h3>
          </button>
        </form>
      </div>
    )
  }
}


export default SearchBar; 